"use client";

import { forwardRef } from "react";
import type { ComponentProps } from "react";

import { Link } from "@/i18n/navigation";

export type NextLinkProps = ComponentProps<typeof Link>;

/**
 * Link component that automatically handles locale prefixing via next-intl
 * To be used for internal navigation within the website
 */
const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ href, ...props }, ref) => <Link href={href} {...props} ref={ref} />
);

NextLink.displayName = "NextLink";

export default NextLink;
